import React from 'react';
import PropTypes from 'prop-types';

import Skeleton from "UI/Skeleton";
import { backgroundStyles } from '../Slide/Slide';

export default class SlideSkeleton extends React.Component
{
    render()
    {
        return <Skeleton
            className='h-64 w-32 rounded bg-gray-400'
            style={{
                width: backgroundStyles.width,
                height: backgroundStyles.height
            }}
        />;
    }
}
